import { config, crFetch, handlers } from '_helpers';

const { handleResponseAsync } = handlers;
const API = config.apiUrl.orionAPI;

async function getAll(accountID) {
  return handleResponseAsync(
    await crFetch(
      {
        method: 'GET',
        url: `/mineplans?accountID=${accountID}`,
      },
      API
    )
  );
}

async function getById(mineplaID) {
  return handleResponseAsync(
    await crFetch(
      {
        method: 'GET',
        url: `/mineplans/${mineplaID}`,
      },
      API
    )
  );
}

async function create(mineplan) {
  return handleResponseAsync(
    await crFetch({
      method: 'POST',
      url: '/mineplans',
      body: mineplan,
      multipart: true,
    })
  );
}

async function update(mineplan) {
  return handleResponseAsync(
    await crFetch(
      {
        method: 'PUT',
        url: '/mineplans',
        body: JSON.stringify(mineplan),
      },
      API
    )
  );
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function del(mineplanID) {
  return handleResponseAsync(
    await crFetch(
      {
        method: 'DELETE',
        url: `/mineplans/${mineplanID}`,
      },
      API
    )
  );
}

const mineplanService = {
  getAll,
  getById,
  create,
  del,
  update
};

export default mineplanService;
